export class ExtendedControlIcons
{
    constructor(first, second, third, fourth) {
        this._first = first;
        this._second = second;
        this._third = third;
        this._fourth = fourth;
    }

    get first() {
        return this._first;
    }

    get second() {
        return this._second;
    }

    get third() {
        return this._third;
    }

    get fourth() {
        return this._fourth;
    }
}